import { render, staticRenderFns } from "./v4-video.vue?vue&type=template&id=10c6eb4f&"
import script from "./v4-video.vue?vue&type=script&lang=js&"
export * from "./v4-video.vue?vue&type=script&lang=js&"
import style0 from "./v4-video.vue?vue&type=style&index=0&lang=postcss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/landun/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('10c6eb4f')) {
      api.createRecord('10c6eb4f', component.options)
    } else {
      api.reload('10c6eb4f', component.options)
    }
    module.hot.accept("./v4-video.vue?vue&type=template&id=10c6eb4f&", function () {
      api.rerender('10c6eb4f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/v4-video/v4-video.vue"
export default component.exports